import { createPaymentIntent, getCardBillingAddress } from '@/models/three-ds-handler';
import PaymentHelper, { paymentMethods } from '@/utils/payment-helper'
const { BOLETO } = paymentMethods

export default {
	methods: {
        isBoletoPaymentMethod() {
            return PaymentHelper.isBoletoPaymentMethod(this.payment_method_type)
        },
        getVoucherPaymentInfo() {
            const formData = this.$store.getters.values("bank_account");
            const custmerData = this.$store.getters.customer_data;
            return {
              customer: {
                "firstName" :  formData.first_name || custmerData.first_name,
                "lastName" : formData.last_name || custmerData.last_name,
                "email": formData.email || custmerData.email,
                "phone" : formData.phone || custmerData.phone,
                "company" : formData.company,
              },
              "billingAddress" : getCardBillingAddress(formData),
              "taxId": formData.tax_id,
            }
          },
      
          submitVoucherCheckout() {
            const cbInstance = Chargebee.getInstance();
            const amount = this.$store.getters.current_amount_due;
            return cbInstance.handlePayment(BOLETO, {
              paymentIntent: () => {
                return createPaymentIntent(this.$store, this.$store.state.order.payment_method, {
                  paymentMethodType: BOLETO,
                  amount: amount
                })
              },
              paymentInfo: this.getVoucherPaymentInfo()
            }).then(intent => {
              this.$store.dispatch("set_payment_intent", intent);
              return intent;
            });
          },
	}
}